import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export const PasswordPrompt = ({ open, title, onSubmit, onCancel }) => {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setPw(""); setErr(""); } }, [open]);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { await onSubmit(pw); } catch (x) { setErr(x.message || "Incorrect password"); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="sm:max-w-sm" data-testid="password-prompt-dialog">
        <DialogHeader>
          <div className="h-10 w-10 rounded-full bg-amber-500/10 text-amber-600 flex items-center justify-center mb-2"><Lock className="h-5 w-5" /></div>
          <DialogTitle>Password required</DialogTitle>
          <DialogDescription>“{title}” is encrypted. Enter its password to open it.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" autoFocus value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Password" data-testid="password-prompt-input" />
          {err && <p className="text-sm text-destructive" data-testid="password-prompt-error">{err}</p>}
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onCancel} data-testid="password-prompt-cancel">Cancel</Button>
            <Button type="submit" disabled={!pw || busy} data-testid="password-prompt-submit">{busy ? "Unlocking…" : "Unlock"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
